<button
  class="chat-toggle-button"
  [class.has-unread]="unreadCount > 0"
  (click)="toggleChat()"
  [attr.aria-label]="'Open chat' + (unreadCount > 0 ? ' - ' + unreadCount + ' unread messages' : '')"
  >
  <div class="button-content">
    <ion-icon name="chatbubbles"></ion-icon>
    @if (unreadCount > 0) {
      <span class="unread-badge">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    }
  </div>

  <div class="ripple-effect"></div>
</button>